/* Filter + sort behaviour for the results page.
   Deliberately small: the form is a plain GET form, so everything works
   without JS. This only removes the extra click. */
(function () {
  function cleanSubmit(form) {
    // Drop empty inputs so the URL stays readable and Shopify doesn't choke
    // on blank price bounds.
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (input.value === '') input.disabled = true;
    });
    form.submit();
  }

  var form = document.querySelector('[data-ktg-autosubmit]');
  if (form) {
    form.addEventListener('change', function (event) {
      if (event.target.type === 'number') return; // wait for blur on text entry
      cleanSubmit(form);
    });

    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('change', function () {
        cleanSubmit(form);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          cleanSubmit(form);
        }
      });
    });
  }

  var sort = document.querySelector('[data-ktg-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();

/* Header search: an empty query returns nothing on Shopify, so browsing a
   department with no search term needs the match-all query instead. */
(function () {
  var form = document.querySelector('[data-ktg-search]');
  if (!form) return;
  form.addEventListener('submit', function () {
    var input = form.querySelector('input[name="q"]');
    if (input && input.value.trim() === '') input.value = '*';
  });
})();

/* Homepage product-row tabs. Panels are all in the markup, so without JS the
   first one still renders; this just switches between them. */
(function () {
  document.querySelectorAll('.ktg-row').forEach(function (row) {
    var tabs = row.querySelectorAll('[data-ktg-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-ktg-tab');

        tabs.forEach(function (other) {
          var on = other === tab;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        row.querySelectorAll('[data-ktg-panel]').forEach(function (panel) {
          var on = panel.getAttribute('data-ktg-panel') === id;
          panel.classList.toggle('is-hidden', !on);
          if (on) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });
})();

/* Hero video: honour reduced-motion by pausing rather than just hiding, so
   the file isn't decoded and burning battery behind a still image. */
(function () {
  var holder = document.querySelector('[data-ktg-hero-video]');
  if (!holder || !window.matchMedia) return;

  var query = window.matchMedia('(prefers-reduced-motion: reduce)');
  function apply() {
    holder.querySelectorAll('video').forEach(function (video) {
      if (query.matches) {
        video.pause();
        video.removeAttribute('autoplay');
      } else if (video.paused) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    });
  }

  apply();
  if (query.addEventListener) query.addEventListener('change', apply);
})();

/* Other conditions of the same card.
   Conditions are separate products in this catalogue, so a shopper landing on
   the Near Mint copy has no way to reach the Lightly Played one. This asks
   Shopify's search suggestions for the same card name and lists the siblings.
   It is additive: if the request fails, the block simply stays hidden. */
(function () {
  var box = document.querySelector('[data-ktg-others]');
  if (!box) return;

  var title = box.getAttribute('data-title') || '';
  var current = box.getAttribute('data-current');
  if (!title) return;

  var url =
    '/search/suggest.json?q=' +
    encodeURIComponent(title) +
    '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';

  fetch(url)
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (data) {
      var items = data && data.resources && data.resources.results && data.resources.results.products;
      if (!items || !items.length) return;

      var short = { 'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG' };
      var list = box.querySelector('.ktg-pdp__otherslist');
      var found = 0;

      /* Two title shapes come out of Grindless, and the sibling match has to
         understand both or retro games never find their other copies:
           cards        "Lightning Bolt (208) - LP"
           video games  "Epic Mickey [Collector's Edition] | (CIB) (Wii)"
         The trailing platform group on the video game shape is part of the
         suffix, not the name, so it is stripped along with the condition. */
      var CARD_SUFFIX = /\s-\s(NM|LP|MP|HP|DMG)$/i;
      var GAME_SUFFIX = /\s\|\s\(([^)]+)\)(?:\s*\([^)]*\))*$/;

      function parts(raw) {
        var m = raw.match(CARD_SUFFIX);
        if (m) return { base: raw.replace(CARD_SUFFIX, ''), label: m[1].toUpperCase() };
        m = raw.match(GAME_SUFFIX);
        if (m) return { base: raw.replace(GAME_SUFFIX, '').trim(), label: m[1].toUpperCase() };
        return { base: raw, label: 'Other' };
      }

      items.forEach(function (item) {
        if (item.handle === current) return;

        // Only siblings: same product name, differing by the condition suffix.
        var bits = parts(item.title);
        if (bits.base.toLowerCase() !== title.toLowerCase()) return;

        var label = bits.label;
        Object.keys(short).forEach(function (full) {
          if (item.title.indexOf(full) !== -1) label = short[full];
        });

        var a = document.createElement('a');
        a.className = 'ktg-pdp__other' + (item.available ? '' : ' ktg-pdp__other--out');
        a.href = item.url;
        a.innerHTML =
          '<span class="ktg-pixel ktg-pdp__otherbadge">' + label + '</span>' +
          '<span class="ktg-pdp__otherprice">' + (item.price ? item.price : '') + '</span>' +
          '<span class="ktg-pdp__otherstate">' + (item.available ? 'In stock' : 'Sold out') + '</span>';
        list.appendChild(a);
        found++;
      });

      if (found) box.hidden = false;
    })
    .catch(function () {});
})();

/* Contact form honeypot.
   The field is off-screen and nothing a person can see, so anything that
   arrives with it filled was filled by a script. Blocking here only stops
   bots that run our JS, which is why it is a second layer rather than the
   defence: Shopify's own hCaptcha is on by default for contact forms and is
   what actually holds the line. Shopify gives the theme no server-side hook
   to reject a submission, so this is as far as the theme can go. */
(function () {
  var form = document.querySelector('.ktg-contact__form');
  if (!form) return;

  var trap = form.querySelector('[name="contact[nickname]"]');
  if (!trap) return;

  form.addEventListener('submit', function (e) {
    if (trap.value !== '') e.preventDefault();
  });
})();

/* Preselect the enquiry topic from ?topic= in the URL, so a link can land
   someone on the right one. This has to happen here rather than in the
   template: Liquid cannot read query strings, and the request object has no
   url property to parse one out of. Matching is loose — trimmed and
   case-insensitive — so a link survives the topic wording being edited in
   the theme editor, and falls back to leaving the first option chosen. */
(function () {
  var select = document.querySelector('[data-ktg-topic]');
  if (!select || !window.URLSearchParams) return;

  var wanted = new URLSearchParams(window.location.search).get('topic');
  if (!wanted) return;

  var needle = wanted.trim().toLowerCase();
  for (var i = 0; i < select.options.length; i++) {
    if (select.options[i].value.trim().toLowerCase() === needle) {
      select.selectedIndex = i;
      return;
    }
  }
})();

/* Hero slideshow.
   Eight shop photos would be most of a megabyte if they all loaded with the
   page, so only the first one ships with a src. Each remaining slide holds
   its URLs in data attributes and is promoted one step before its turn,
   which keeps the initial homepage cost to a single image.

   Additive: with no JS the first slide is a perfectly good static hero. */
(function () {
  var boxes = document.querySelectorAll('[data-ktg-slideshow]');
  if (!boxes.length) return;

  Array.prototype.forEach.call(boxes, function (box) {
  var slides = box.querySelectorAll('.ktg-hero__slide');
  if (slides.length < 2) return;

  function load(el) {
    if (!el || el.getAttribute('data-loaded')) return;
    var srcset = el.getAttribute('data-srcset');
    var src = el.getAttribute('data-src');
    if (srcset) el.srcset = srcset;
    if (src) el.src = src;
    el.setAttribute('data-loaded', '1');
  }

  // Someone who asked for reduced motion gets one photo and no movement.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;

  var seconds = parseFloat(box.getAttribute('data-interval'));
  if (!seconds || seconds < 1) seconds = 6;

  var current = 0;
  load(slides[1]);

  setInterval(function () {
    // Nothing to see on a background tab, so skip the work and the fetch.
    if (document.hidden) return;

    var next = (current + 1) % slides.length;
    slides[current].classList.remove('is-active');
    slides[next].classList.add('is-active');
    current = next;

    // Stay one ahead so the next fade never waits on the network.
    load(slides[(next + 1) % slides.length]);
  }, seconds * 1000);
  });
})();

/* Add to cart without leaving the page.
   Our cards and product page use plain <form> posts, which navigate to /cart
   and never open Dawn's drawer. This posts to the cart AJAX endpoint instead,
   asks Shopify to re-render the drawer and the header count, and opens the
   drawer. If anything fails it falls back to submitting the form normally, so
   adding to cart always works. */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function replaceSection(html, selector) {
    var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    var existing = document.querySelector(selector);
    if (incoming && existing) existing.innerHTML = incoming.innerHTML;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ktg-add]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('[name="add"]');
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    var body = new FormData(form);
    body.append('sections', SECTIONS);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.json && result.json.description);

        var sections = result.json.sections || {};
        if (sections['cart-icon-bubble']) replaceSection(sections['cart-icon-bubble'], '#cart-icon-bubble');

        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          replaceSection(sections['cart-drawer'], 'cart-drawer');
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') {
            drawer.open();
          } else {
            drawer.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        } else {
          window.location.href = '/cart';
          return;
        }

        if (button) {
          button.textContent = 'Added';
          setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, 1200);
        }
      })
      .catch(function () {
        // Never trap a customer: let the browser do the normal POST.
        if (button) {
          button.textContent = original;
          button.disabled = false;
        }
        form.submit();
      });
  });
})();

/* Filter panel toggle (phones only; the button is hidden on desktop). */
(function () {
  var toggle = document.querySelector('[data-ktg-facets-toggle]');
  if (!toggle) return;
  var body = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!body) return;

  toggle.addEventListener('click', function () {
    var open = body.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
